module.exports = __webpack_public_path__ + "static/media/register_background_mobile.9f04a682.png";